module.exports = __webpack_public_path__ + "img/img_home.cdaf74a.png";